import { render, staticRenderFns } from "./PersonPerformanceDetail.vue?vue&type=template&id=ca82d1ec&scoped=true&"
import script from "./PersonPerformanceDetail.vue?vue&type=script&lang=js&"
export * from "./PersonPerformanceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca82d1ec",
  null
  
)

export default component.exports